import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { StateService } from '../state.service';
import { NewsletterApi } from '../newsletter-api.service';
import { ResourceService } from '../resources.service';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.css']
})
export class StartComponent implements OnInit {

  constructor( 
    private route: ActivatedRoute,
    private router: Router,
    private stateService: StateService,
    private api: NewsletterApi,
    private r: ResourceService) { }

  ngOnInit() {
    // Handle DNN language change (which keeps the parameters but removes /settings)
    var params = this.route.snapshot.queryParams;
    if(params.hash)
      this.router.navigate(['/settings'], { queryParams: params });
  }

  nextStep() {
    this.api.subscriberExists(this.stateService.email).subscribe(exists => {
      // If the subscriber exists, navigate to the send link page. If not, go directly to the settings page.
      if(!exists)
        this.router.navigate(['/settings']);
      else
        this.router.navigate(['/send-link']);
    });
  }

}
